"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbortMultipartUploadInput_1 = require("./AbortMultipartUploadInput");
var AbortMultipartUploadOutput_1 = require("./AbortMultipartUploadOutput");
var NoSuchUpload_1 = require("./NoSuchUpload");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.AbortMultipartUpload = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "AbortMultipartUpload",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: AbortMultipartUploadInput_1.AbortMultipartUploadInput
    },
    output: {
        shape: AbortMultipartUploadOutput_1.AbortMultipartUploadOutput
    },
    errors: [
        {
            shape: NoSuchUpload_1.NoSuchUpload
        }
    ]
};
//# sourceMappingURL=AbortMultipartUpload.js.map